import { useQuery } from '@tanstack/react-query';
import { GeofenceCategory } from '@models/geofence.model';
import { geofenceService } from '@services/geofence';

export const GEOFENCE_CATEGORIES_QUERY_KEY = ['geofenceCategories'];

export const useGeofenceCategories = () => {
  return useQuery<GeofenceCategory[], Error>({
    queryKey: GEOFENCE_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const categories = await geofenceService.getGeofenceCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export const useActiveGeofenceCategories = () => {
  return useQuery<GeofenceCategory[], Error>({
    queryKey: [...GEOFENCE_CATEGORIES_QUERY_KEY, 'active'],
    queryFn: async () => {
      const categories = await geofenceService.getActiveGeofenceCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export const useGlobalGeofenceCategories = () => {
  return useQuery<GeofenceCategory[], Error>({
    queryKey: [...GEOFENCE_CATEGORIES_QUERY_KEY, 'global'],
    queryFn: async () => {
      const categories = await geofenceService.getGlobalGeofenceCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export default useGeofenceCategories;
